// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const LeaveTypesPage = lazy(() => import('./pages/LeaveTypesPage'));
const LeaveAccrualPage = lazy(() => import('./pages/LeaveAccrualPage'));
const AttendancePage = lazy(() => import('./pages/AttendancePage'));
const ShiftsPage = lazy(() => import('./pages/ShiftsPage'));
const OvertimePage = lazy(() => import('./pages/OvertimePage'));
const BulkLeaveApprovalPage = lazy(() => import('./pages/BulkLeaveApprovalPage'));
const LeaveCalendarPage = lazy(() => import('./pages/LeaveCalendarPage'));
const WfhPage = lazy(() => import('./pages/WfhPage'));

export const AttendanceRoutes: RouteObject = {
  path: 'attendance',
  element: <ModuleGuard moduleId="people.attendance" />,
  handle: { crumb: 'Leave & Attendance' },
  children: [
    { index: true, element: <Navigate to="leave-types" replace /> },
    { path: 'leave-types', element: <LeaveTypesPage />, handle: { crumb: 'Leave Types' } },
    { path: 'leave-accrual', element: <LeaveAccrualPage />, handle: { crumb: 'Leave Accrual' } },
    { path: 'attendance', element: <AttendancePage />, handle: { crumb: 'Attendance' } },
    { path: 'shifts', element: <ShiftsPage />, handle: { crumb: 'Shifts' } },
    { path: 'overtime', element: <OvertimePage />, handle: { crumb: 'Overtime' } },
    { path: 'bulk-leave-approval', element: <BulkLeaveApprovalPage />, handle: { crumb: 'Bulk Leave Approval' } },
    { path: 'leave-calendar', element: <LeaveCalendarPage />, handle: { crumb: 'Leave Calendar' } },
    { path: 'wfh', element: <WfhPage />, handle: { crumb: 'Work From Home' } },
  ],
};
